import { render, staticRenderFns } from "./syncPermissions.vue?vue&type=template&id=cb3abe7e&scoped=true"
import script from "./syncPermissions.vue?vue&type=script&lang=js"
export * from "./syncPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3abe7e",
  null
  
)

export default component.exports